<template>
  <div class="narrow flexbox align-center full-height" style="justify-content:space-between;">
    <div class="brand">
      <img src="https://static.newsbx.com/newsbx/logo/logo-white.svg"/>
    </div>
    <div>
      <span v-if="self !== null">{{ self.name }}&nbsp;&nbsp;</span>
      <el-button type="text" @click="logout" class="text-white">
        {{ $t('sign_out') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'self'
    ])
  },
  methods: {
    logout () {
      localStorage.removeItem('operator_access_token')
      location.reload()
    }
  }
}
</script>
